module.exports = __webpack_public_path__ + "img/alignment.7e812f98.svg";